const compare = require('./compare')
const lte = (a, b, loose) => compare(a, b, loose) <= 0
module.exports = lte



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/~/semver/functions/lte.js
// module id = 202
// module chunks = 1